import { useCallback, useEffect, useRef, useState } from 'react'

export function useScrollPosition() {
  const [showStickyHeader, setShowStickyHeader] = useState(false)
  const tickingRef = useRef(false)

  const checkScroll = useCallback(() => {
    const shouldShowSticky = window.scrollY > 385
    setShowStickyHeader(shouldShowSticky)
    tickingRef.current = false
  }, [])

  const requestTick = useCallback(() => {
    if (!tickingRef.current) {
      requestAnimationFrame(checkScroll)
      tickingRef.current = true
    }
  }, [checkScroll])

  useEffect(() => {
    checkScroll()

    window.addEventListener('scroll', requestTick, { passive: true })

    return () => {
      window.removeEventListener('scroll', requestTick)
    }
  }, [requestTick, checkScroll])

  return showStickyHeader
}
